import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Reference, Property, Name, Output } from '@components/Reference';
import { Spacer } from '@cleartrip/bento/lib';
import Sandbox from '@components/Sandbox';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">




    <h1 {...{
      "id": "display"
    }}>{`Display`}</h1>
    <p>{`Utility classes to control the display properties of an element`}</p>
    <h2 {...{
      "id": "class-reference"
    }}>{`Class reference`}</h2>
    <Reference mdxType="Reference">
    <Property mdxType="Property">
        <Name mdxType="Name">.d-block</Name>
        <Output mdxType="Output">display: block;</Output>
    </Property>
    <Property mdxType="Property">
        <Name mdxType="Name">.d-inline-block</Name>
        <Output mdxType="Output">display: inline-block;</Output>
    </Property>
    <Property mdxType="Property">
        <Name mdxType="Name">.d-inline</Name>
        <Output mdxType="Output">display: inline;</Output>
    </Property>
    <Property mdxType="Property">
        <Name mdxType="Name">.d-flex</Name>
        <Output mdxType="Output">display: flex;</Output>
    </Property>
    <Property mdxType="Property">
        <Name mdxType="Name">.d-inline-flex</Name>
        <Output mdxType="Output">display: inline-flex;</Output>
    </Property>
    <Property mdxType="Property">
        <Name mdxType="Name">.d-table</Name>
        <Output mdxType="Output">display: table;</Output>
    </Property>
    <Property mdxType="Property">
        <Name mdxType="Name">.d-table-row</Name>
        <Output mdxType="Output">display: table-row;</Output>
    </Property>
    <Property mdxType="Property">
        <Name mdxType="Name">.d-table-cell</Name>
        <Output mdxType="Output">display: table-cell;</Output>
    </Property>
    <Property mdxType="Property">
        <Name mdxType="Name">.d-none</Name>
        <Output mdxType="Output">display: none;</Output>
    </Property>
    <Property mdxType="Property">
        <Name mdxType="Name">.d-unset</Name>
        <Output mdxType="Output">display: unset;</Output>
    </Property>
  </Reference>
    <h2 {...{
      "id": "block"
    }}>{`Block`}</h2>
    <p><inlineCode parentName="p">{`.d-block`}</inlineCode>{` creates block level elements.`}</p>
    <Sandbox mdxType="Sandbox">
  <Sandbox.Preview>
    <div className="bg-tertiary-400 c-white d-block">
      <div className="flex flex-center flex-middle h-10">
        This takes up all the available space
      </div>
    </div>
  </Sandbox.Preview>
  <Sandbox.Code>
    <div className="d-block">...</div>
  </Sandbox.Code>
    </Sandbox>
    <h2 {...{
      "id": "inline-block"
    }}>{`Inline Block`}</h2>
    <p><inlineCode parentName="p">{`.d-inline-block`}</inlineCode>{` creates inline elements which behave as blocks.`}</p>
    <Sandbox mdxType="Sandbox">
  <Sandbox.Preview>
    <div className="bg-tertiary-400 c-white d-inline-block mr-3">
      <div className="flex flex-middle flex-center h-10">
        This only
      </div>
    </div>
        <div className="bg-tertiary-400 c-white d-inline-block mr-3">
  <div className="flex flex-middle flex-center h-10">
    takes as much space
  </div>
        </div>

        <div className="bg-tertiary-400 c-white d-inline-block">
  <div className="flex flex-middle flex-center h-10">
    as it needs
  </div>
        </div>
  </Sandbox.Preview>
  <Sandbox.Code>
    <div className="d-block">...</div>
  </Sandbox.Code>
    </Sandbox>
    <h2 {...{
      "id": "inline"
    }}>{`Inline`}</h2>
    <p><inlineCode parentName="p">{`.d-inline`}</inlineCode>{` creates inline elements.`}</p>
    <Sandbox mdxType="Sandbox">
  <Sandbox.Preview>
    <div className="bg-tertiary-400 c-white d-inline-block mr-3">
      this is an inline element
    </div>
  </Sandbox.Preview>
  <Sandbox.Code>
    <div className="d-block">...</div>
  </Sandbox.Code>
    </Sandbox>
    <h2 {...{
      "id": "flex"
    }}>{`Flex`}</h2>
    <p><inlineCode parentName="p">{`.d-flex`}</inlineCode>{` creates a top level flex element.`}</p>
    <Sandbox mdxType="Sandbox">
  <Sandbox.Preview>
    <div className="bg-tertiary-100 d-flex">
        <div className="flex flex-1 flex-middle flex-center bg-tertiary-400 c-white mx-1 h-10">
          1
        </div>
        <div className="flex flex-1 flex-middle flex-center bg-tertiary-400 c-white mx-1 h-10">
          2
        </div>
        <div className="flex flex-1 flex-middle flex-center bg-tertiary-400 c-white mx-1 h-10">
          3
        </div>
    </div>
  </Sandbox.Preview>
  <Sandbox.Code>
    <div className="d-flex">...</div>
  </Sandbox.Code>
    </Sandbox>
    <h2 {...{
      "id": "table"
    }}>{`Table`}</h2>
    <p>{`Using `}<inlineCode parentName="p">{`d-table`}</inlineCode>{`, `}<inlineCode parentName="p">{`d-table-row`}</inlineCode>{`, `}<inlineCode parentName="p">{`d-table-cell`}</inlineCode>{` it is possibl e to emulate a table built with `}<inlineCode parentName="p">{`<table>`}</inlineCode>{`, `}<inlineCode parentName="p">{`<tr>`}</inlineCode>{` and `}<inlineCode parentName="p">{`<td>`}</inlineCode>{` respectively.`}</p>
    <Sandbox mdxType="Sandbox">
  <Sandbox.Preview>
    <div className="d-table w-full">
      <div className="d-table-row">
        <div className="d-table-cell px-4 py-2">Cell 1</div>
        <div className="d-table-cell px-4 py-2">Cell 2</div>
        <div className="d-table-cell px-4 py-2">Cell 3</div>
      </div>
      <div className="d-table-row">
        <div className="d-table-cell px-4 py-2">Cell 4</div>
        <div className="d-table-cell px-4 py-2">Cell 5</div>
        <div className="d-table-cell px-4 py-2">Cell 6</div>
      </div>
    </div>
  </Sandbox.Preview>
  <Sandbox.Code>
    <div className="d-block">...</div>
  </Sandbox.Code>
    </Sandbox>
    <h2 {...{
      "id": "none"
    }}>{`None`}</h2>
    <p>{`Using `}<inlineCode parentName="p">{`d-none`}</inlineCode>{`. Hides the element from the browser but also removes it from the dom`}</p>
    <Sandbox mdxType="Sandbox">
  <Sandbox.Preview>
    <div className="d-none w-full">
      <p>lorem</p>
    </div>
  </Sandbox.Preview>
  <Sandbox.Code>
    <div className="d-none">...</div>
  </Sandbox.Code>
    </Sandbox>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      